var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('AppBar',{attrs:{"title":"솔루션 샘플 페이지"}}),_c(_vm.tarComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }